import { getSrcs, imageUrl } from '@helpers/image';
import { SystemIcon, getSvgFromSystem } from '@helpers/systemIcons';
import { withMotionMax } from '@hoc/withMotionMax';
import { useModalGallery } from '@hooks/useModalGallery';
import ModalGallery from '@stories/Components/Global/ModalGallery/ModalGallery';
import ModalGalleryProvider from '@stories/Components/Global/ModalGallery/ModalGalleryProvider/ModalGalleryProvider';
import { MotionConfig } from 'framer-motion';
import React, { useState } from 'react';
import CarouselProvider from '../Carousel/CarouselProvider/CarouselProvider';
import Connected from '../Carousel/Connected/Connected';
import { ImageGalleryStyles as S } from './ImageGallery.styles';
const ImageGallery = ({ id, items }) => {
    const [currentImage, setCurrentImage] = useState(items[0]);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [currentCopyrightInfo, setCurrentCopyrightInfo] = useState(items[0].citation);
    const [currentCopyrightInfoPosition, setCurrentCopyrightInfoPosition] = useState(items[0].citationPosition);
    const wrapper = React.useRef(null);
    useModalGallery({ count: items.length });
    const [modalOpen, setModalOpen] = React.useState(false);
    const [goToIndex, setGoToIndex] = React.useState(0);
    let imageSrc;
    let imageSrcSet;
    if (items.length > 1) {
        imageSrc = getSrcs(currentImage, 880, 320, 4, 9 / 16)[0].split(' ')[0];
        imageSrcSet = getSrcs(currentImage, 880, 320, 4, 9 / 16).join(',');
    }
    else {
        imageSrc = getSrcs(currentImage, 880, 320, 4)[0].split(' ')[0];
        imageSrcSet = getSrcs(currentImage, 880, 320, 4).join(',');
    }
    return (React.createElement(MotionConfig, { transition: { duration: 0.45, ease: 'easeOut' } },
        React.createElement(ModalGalleryProvider, { count: items.length },
            React.createElement(CarouselProvider, { count: items.length },
                React.createElement(S.Container, { id: id, innerWidth: "narrow", flush: "top" }, items && (React.createElement(React.Fragment, null,
                    React.createElement(S.MainImageWrapper, null,
                        React.createElement(S.MainImage, { alt: currentImage.altText, loading: "lazy", role: currentImage.altText ? undefined : 'presentation', src: imageSrc, srcSet: imageSrcSet, onClick: () => {
                                setModalOpen(true);
                                setGoToIndex(currentImageIndex);
                            }, width: "880" }),
                        currentCopyrightInfo && (React.createElement(S.CopyrightInformation, { "data-copyright-info-position": currentCopyrightInfoPosition },
                            "\u00A9 ",
                            currentCopyrightInfo))),
                    currentImage.caption &&
                        React.createElement(S.ImageCaption, null, currentImage.caption),
                    items.length > 1 && (React.createElement(S.GalleryNavWrapper, null,
                        React.createElement(S.GalleryNav, { ref: wrapper },
                            React.createElement(S.Track, { trackMutations: true, enableCarousel: true }, items.map((item, i) => (React.createElement(S.Item, { key: `card-${i}` },
                                React.createElement(S.Thumbnail, { alt: items[i].altText, loading: "lazy", role: items[i].altText ? undefined : 'presentation', src: imageUrl(items[i], { width: 180, height: 112 }), onClick: () => updateStates(items, i) }))))),
                            React.createElement(Connected, null, () => (React.createElement(S.Controls, { wrap: false, renderPrev: (buttonProps) => (React.createElement(S.Button, { "aria-label": "previous", ...buttonProps }, getSvgFromSystem(SystemIcon.HoverArrowRight))), renderNext: (buttonProps) => (React.createElement(S.Button, { "aria-label": "next", ...buttonProps }, getSvgFromSystem(SystemIcon.HoverArrowRight))) })))))))))),
            React.createElement(ModalGallery, { ariaLabel: "Image Gallery", isOpen: modalOpen, openIndex: goToIndex, media: items, closeOnBackground: true, showBackground: true, showClose: true, onClose: () => setModalOpen(false) }))));
    function updateStates(items, index) {
        setCurrentImage(items[index]);
        setCurrentImageIndex(index);
        setCurrentCopyrightInfo(items[index].citation);
        setCurrentCopyrightInfoPosition(items[index].citationPosition);
    }
};
export default withMotionMax(ImageGallery);
